import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { GetTagsById, AddTags } from '../services/tagservice';
import slugify from 'slugify';

function TagNew() {
    const [name, setName] = useState('');
    const [slug, setSlug] = useState('');
    const [pk, setPk] = useState(0);
	const [metatitle, setMetaTitle] = useState('');
    const [metadesc, setMetaDesc] = useState('');
    const [metakeywords, setMetaKeywords] = useState('');
    let navigate = useNavigate();  
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Extract query parameters
    const id = queryParams.get('pk') || null; // e.g., ?id=18
    
    useEffect(() => {
        if(id != null)
            {
                fillData (id);
                setPk(id);
            }
    }, []); 

    const handleNameChange = (event) => {
            setName(event.target.value);
            setSlug(slugify(event.target.value, { lower: true, strict:true }));
          };
    const fillData  = async (id) => {
        try {
            const tagDetail = await GetTagsById(id);
            const jsonData = JSON.parse(tagDetail);
            setName(jsonData.name);
            setSlug(jsonData.paramlink);  
			setMetaTitle(jsonData.metatitle);
            setMetaDesc(jsonData.metadesc);
            setMetaKeywords(jsonData.metakeywords);  			
          } catch (error) {
            console.error('Error fetching the data:', error);
          }
    }

    const handleSave = async () => {
        try {
            const response = AddTags(
                JSON.stringify({
                    Pk: pk,
                    Name: name,
                    Paramlink: slug,
                    Metatitle: metatitle,
                    Metadesc: metadesc,
                    Metakeywords: metakeywords
                }));

            if(pk == 0)
                navigate('/tags', { state: { successMessage: 'New tag record added' } });
            else
                navigate('/tags', { state: { successMessage: 'Tag record updated' } });

        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }

    const handleCancel = async () => {
        navigate('/tag/');
    }

    return (
        <>
            <div class="row">
                <div class="col-md-6 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">Add new tag</h4>
                            
                            <form class="forms-sample">
                                <div class="form-group">
                                    <label for="txtName">Name</label>
                                    <input type="text" class="form-control" id="txtName" onChange={handleNameChange} placeholder="Name" value={name}/>
                                </div>

                                <div class="form-group">
                                    <label for="txtParamLink">Param Link</label>
                                    <input type="text" class="form-control" id="txtParamLink" placeholder="Param Link" value={slug} />
                                </div>
                               
							    <div class="form-group">
                                    <label for="txtMetaTitle">Meta Title</label>
                                    <input type="text" class="form-control" id="txtMetaTitle" onChange={(e) => setMetaTitle(e.target.value)} placeholder="Meta Title" value={metatitle}/>
                                </div>

                                <div class="form-group">
                                    <label for="txtMetaDesc">Meta Desc</label>
                                    <input type="text" class="form-control" id="txtMetaDesc" onChange={(e) => setMetaDesc(e.target.value)} placeholder="Meta Description" value={metadesc}/>
                                </div>

                                <div class="form-group">
                                    <label for="txtMetaKeywords">Meta Keywords</label>
                                    <input type="text" class="form-control" id="txtMetaKeywords" onChange={(e) => setMetaKeywords(e.target.value)} placeholder="Meta Keywords" value={metakeywords}/>
                                </div>
								
                                <button type="button" class="btn btn-primary me-2" onClick={() => handleSave() }>Submit</button>
                                <button class="btn btn-light" onClick={() => handleCancel() }>Cancel</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TagNew;
